module.exports = __webpack_public_path__ + "img/1x.95e0ae9.jpg";